// extracted by mini-css-extract-plugin
export default {"productDescription":"k_-z","featuredDescription":"l_-z","description":"m_-z","more":"n_-z","descriptionSku":"o_-z"};